module.exports = __webpack_public_path__ + "img/popular-cities.459b88f2.png";